import React from 'react';

const STEP_NAMES = [
  'Profile',
  'Education',
  'Experience',
  'Skills',
  'Activity',
  'Link',
];

const MobileStepHeader = ({ currentStep, totalSteps = 6, resumeScore }) => {
  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className='md:hidden w-full border-b border-grayscale-gray02'>
      <div className='flex items-baseline justify-between px-4 py-2 typo-b13'>
        <span className='text-text-primary'>
          STEP {currentStep + 1}
          <span className='text-text-placeholder'> of {totalSteps}</span>
        </span>
        <span className='text-text-placeholder'>{resumeScore}%</span>
      </div>

      <div className='w-full h-1 bg-grayscale-gray00'>
        <div
          className='h-full bg-green-deep02 transition-all duration-300'
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default MobileStepHeader;
